/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  customerManage.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:32
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import {axiosAPIUrl, Parameter, assignParams} from "./index"

/**
 * 客户标签
 */
export class TagListDto {
    tagId?: string;
    tagColor?: string;
    tagName?: string;
}

/**
 * 客户分组
 */
export class GroupListDto {
    groupId?: string;
    groupName?: string;
}

/**
 * 客户级别
 */
export class LevelListDto {
    levelId: string;
    customerLevelId?: string;
    levelName: string;
    levelType: string;
    levelTypeName: string;
    buyDiscount: string;
}

/* 客户列表信息 */
export class CustomerListDto {
    /* 关联编号 */
    relationId: string;
    /* 公司编号 */
    companyId: string;
    /* 公司地址 */
    addressId: string;
    /* 公司地址描述 */
    addressName: string;
    /* 公司地址明细 */
    addressDtl: string;
    /* 客户编号 */
    merchantsId: string;
    /* 客户名称 */
    merchantsName: string;
    /* 客户备注 */
    merchantsRemark: string;
    /* 公司头像 */
    logoUrl: string;
    /* 客户编码 */
    merchantsCode: string;
    /* 是否允许客户在我的商城订货 */
    isAllowBuy: boolean
    /* 客户分组 */
    groupId: string;
    /* 客户分组名称 */
    groupName: string;
    /* 客户级别 */
    levelId: string;
    /* 客户级别名称 */
    levelName: string;
    /* 所属部门 */
    deptId: string;
    /* 所属部门名称 */
    deptName: string;
    /* 维护人员 */
    maintainId: string;
    /* 维护人员名称 */
    maintainName: string;
    /* 推荐人 */
    recommendId: string;
    /* 推荐人名称 */
    recommendName: string;
    /* 备注信息 */
    remark: string;
    /* 客户标签列表 */
    tagList: TagListDto[];
    disabled?: boolean;
    isOpen?: boolean;
}

export class CustomerSettingDto {
    /* 关联编号 */
    relationId: string;
    /* 公司编号 */
    companyId: string;
    /* 客户编号 */
    merchantsId: string;
    /* 客户名称 */
    merchantsName: string;
    /* 客户备注 */
    merchantsRemark: string;
    /* 客户编码 */
    merchantsCode: string;
    /* 是否允许客户在我的商城订货 */
    isAllowBuy: boolean
    /* 客户分组 */
    groupId: string;
    /* 客户分组名称 */
    groupName: string;
    /* 客户级别 */
    levelId: string;
    /* 客户级别名称 */
    levelName: string;
    /* 客户类别 */
    merchantsType: string;
    /* 客户类别中文描述 */
    merchantsTypeName: string;
    /* 所属部门 */
    deptId: string;
    /* 所属部门名称 */
    deptName: string;
    /* 维护人员 */
    maintainId: string;
    /* 维护人员名称 */
    maintainName: string;
    /* 推荐人 */
    recommendId: string;
    /* 推荐人名称 */
    recommendName: string;
    /* 备注信息 */
    remark: string;
    /* 签约开始时间 */
    appointmentStart: string;
    /* 签约结束 */
    appointmentEnd: string;
    /* 客户标签列表 */
    tagList: TagListDto[]
}

/* 搜索客户列表数据 */
export class CompanyListDto {
    /* 公司logo */
    logoUrl: string;
    /* 公司编号 */
    companyId: string;
    /* 公司名称 */
    companyName: string;
    companyCode: string;
}

/* 公司详细信息数据 */
export class CompanyInfoDto {
    /* 公司编号 */
    companyId: string;
    /* 公司名称 */
    companyName: string;
    /* 行业 */
    industryId: string;
    /* 行业名称 */
    industryName: string;
    /* 邀请码 */
    inviteCode: string;
    /* 公司地址 */
    address: string;
    addressName: string;
    /* 公司地址明细 */
    addressDtl: string;
    /* 法人 */
    legalPerson: string;
    /* 公司简介 */
    companyInfo: string;
    /* 是否企业认证 */
    isCertification: boolean;
    /* 公司logo */
    logoUrl: string;
    /* 邮箱 */
    companyEmail: string;
    /* 公司网站 */
    companyWebsite: string;
    /* 纳税人编号 */
    taxpayerNo: string;
    /* 发票抬头 */
    invoiceHeader: string;
    /* 服务热线 */
    serviceLineList: ServiceLineListDto[];
    /* 账户列表 */
    accountList: AccountListDto[];
    /* 收货地址列表 */
    addressList: AddressListDto[];
}

export class ServiceLineListDto {
    lineName: string;
    linePhone: string;
}

export class AccountListDto {
    accountName: string;
    accountBank: string;
    accountId: string;
}

export class AddressListDto {
    /* 自动编号 */
    autoId: string;
    /* 收货地址 */
    addressId: string;
    /* 收货地址描述 */
    addressName: string;
    /* 收货地址明细 */
    addressDtl: string;
    /* 是否默认收货地址 */
    isDefault: boolean;
    /* 收货人电话 */
    receiveMobile: string;
    /* 收货人 */
    receiveMan: string;
}

export class ApplyListDto {
    merchantsName: string;
    applyId: string;
    companyId: string;
    merchantsId: string;
    applyStatusName: string;
    applyMessage: string;
    applyStatus: number;
    logoUrl: string;
    /* 独立编码 */
    companyCode: string;
}

export class EmployeeDto {
    EMPLOYEEID: string // 员工编号
    EMPLOYEENAME?: string // 员工姓名
    ISENABLED?: string // 是否启用 1：是，0否
    ORGNAME?: string // 部门名称
    POSITIONNAME?: string // 职位名称
    USERNAME?: string // 登录账号
    EMAIL?: string // 邮箱
    MOBILEPHONE?: string // 手机号
    disabled?:boolean
}

export class DepDto {
    tenantId?: string // 租户号
    parentId?: string // 父级编号
    orgId?: string // 机构id
    levelIds?: string // 所有父级编号（包含自身）
    orgName?: string // 组织名
    isEnabled?: string // 是否启用 1：是，0否
    orgType?: string | number // 组织类型 1公司 2部门分类<管理员/业务员/运营/财务> 3子部门
    isOrgAdmin?: string // 部门类型是否启用 1：是，0否
    orgList?: Array<DepDto> // 下级机构
    disabled?: boolean // 是否禁用
}

/**
 * 获取客户列表
 * @param parameter
 */
export function getMerchantsList(params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<CustomerListDto>>>({
        url: "/cykjoperation/merchantsQuery/getMerchantsList",
        method: "post",
        data: {...params, ...assignParams()},
    });
}

// CM005获取客户申请未处理条数
export function getMerchantsApplyListNum(params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<any>>({
        url: '/cykjoperation/merchantsQuery/getMerchantsApplyListNum',
        method: 'post',
        data: {...params, ...assignParams()},
        extraParams: {
          showLoading: false
        }
    })
}

/**
 * 获取客户详情
 * @param parameter
 */
export function getMerchantsDtl(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<CustomerListDto>>({
        url: "/cykjoperation/merchantsQuery/getMerchantsDtl",
        method: "post",
        data: parameter,
    });
}

/**
 * 删除客户
 * @param parameter
 */
export function deleteMerchants(params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<CustomerListDto>>({
        url: "/cykjoperation/merchantManage/deleteMerchants",
        method: "post",
        data: {...params, ...assignParams()},
    });
}

/**
 * 搜索客户列表
 * @param parameter
 */
export function findMerchantsList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<CompanyListDto>>>({
        url: "/cykjoperation/merchantsQuery/findMerchantsList",
        method: "post",
        data: parameter,
    });
}

/**
 * 获取公司详细信息
 * @param parameter
 */
export function getCompanyDtl(parameter: Parameter = {}, showLoading = true) {
    return axiosAPIUrl<Ajax.Response<CompanyInfoDto>>({
        url: "/cykjoperation/companyQuery/getCompanyDtl",
        method: "post",
        data: parameter,
        extraParams: {
            showLoading: showLoading
        }
    });
}

/**
 * 获取客户标签列表
 * @param parameter
 */
export function getMerchantsTagList(params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<{ companyId: string, tagList: TagListDto[] }>>({
        url: "/cykjoperation/merchantsQuery/getMerchantsTagList",
        method: "post",
        data:{...params, ...assignParams()},
    });
}

/**
 * 新增客户标签
 * @param parameter
 */
export function addMerchantsTag(params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<{id?: string}>>({
        url: "/cykjoperation/merchantManage/addMerchantsTag",
        method: "post",
        data: {...params, ...assignParams()},
    });
}

/**
 * 修改客户标签
 * @param parameter
 */
export function editMerchantsTag(params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjoperation/merchantManage/modifyMerchantsTag",
        method: "post",
        data: {...params, ...assignParams()},
    });
}

/**
 * 删除客户标签
 * @param parameter
 */
export function delMerchantsTag(params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjoperation/merchantManage/deleteMerchantsTag",
        method: "post",
        data: {...params, ...assignParams()},
    });
}

/**
 * 获取客户分组列表
 * @param parameter
 */
export function getMerchantsGroupList(params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<{ companyId: string, groupList: GroupListDto[] }>>({
        url: "/cykjoperation/merchantsQuery/getMerchantsGroupList",
        method: "post",
        data: {...params, ...assignParams()},
    });
}

/**
 * 新增客户分组
 * @param parameter
 */
export function addMerchantsGroup(params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<{id?: string}>>({
        url: "/cykjoperation/merchantManage/addMerchantsGroup",
        method: "post",
        data:  {...params, ...assignParams()},
    });
}

/**
 * 修改客户分组
 * @param parameter
 */
export function editMerchantsGroup(params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjoperation/merchantManage/modifyMerchantsGroup",
        method: "post",
        data: {...params, ...assignParams()},
    });
}

/**
 * 删除客户分组
 * @param parameter
 */
export function delMerchantsGroup(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjoperation/merchantManage/deleteMerchantsGroup",
        method: "post",
        data:{...parameter, ...assignParams()},
    });
}

/**
 * 获取客户级别列表
 * @param parameter
 */
export function getMerchantsLevelList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<{ companyId: string, levelList: LevelListDto[] }>>({
        url: "/cykjoperation/merchantsQuery/getMerchantsLevelList",
        method: "post",
        data: {...parameter, ...assignParams()},
    });
}

/**
 * 新增客户级别
 * @param parameter
 */
export function addMerchantsLevel(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<{id?: string}>>({
        url: "/cykjoperation/merchantManage/addMerchantsLevel",
        method: "post",
        data: {...parameter, ...assignParams()},
    });
}

/**
 * 修改客户级别
 * @param parameter
 */
export function editMerchantsLevel(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjoperation/merchantManage/modifyMerchantsLevel",
        method: "post",
        data: {...parameter, ...assignParams()},
    });
}

/**
 * 删除客户级别
 * @param parameter
 */
export function delMerchantsLevel(params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjoperation/merchantManage/deleteMerchantsLevel",
        method: "post",
        data: {...params, ...assignParams()},
    });
}

/**
 * 获取客户申请列表
 * @param parameter
 */
export function getMerchantsApplyList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<ApplyListDto>>>({
        url: "/cykjoperation/merchantsQuery/getMerchantsApplyList",
        method: "post",
        data: parameter,
    });
}

/**
 * 处理客户申请
 * @param parameter
 */
export function handleMerchantsApply(params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjoperation/merchantManage/handleMerchantsApply",
        method: "post",
        data:{...params, ...assignParams()},
    });
}

// CQ获取公司是否通过申请设置
export function getCompanyIsApplySet(params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<any>>({
        url: '/cykjoperation/companyQuery/getCompanyIsApplySet',
        method: 'post',
        data: {...params, ...assignParams()},
    })
}

/**
 * 是否自动通过客户申请
 * @param parameter
 */
export function modifyIsAutoPass(params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjoperation/merchantManage/modifyIsAutoPass",
        method: "post",
        data: {...params, ...assignParams()},
    });
}

export class CustomerApplyDto {
    /* 客户备注 */
    merchantsRemark: string;
    /* 客户编码 */
    merchantsCode: string;
    /* 是否允许客户在我的商城订货 */
    isAllowBuy: boolean
    /* 客户分组 */
    groupId: string;
    /* 客户分组名称 */
    groupName: string;
    /* 客户级别 */
    levelId: string;
    /* 客户级别名称 */
    levelName: string;
    /* 客户类别 */
    merchantsType: string;
    /* 客户类别中文描述 */
    merchantsTypeName: string;
    /* 所属部门 */
    deptId: string;
    /* 所属部门名称 */
    deptName: string;
    /* 维护人员 */
    maintainId: string;
    /* 维护人员名称 */
    maintainName: string;
    /* 推荐人 */
    recommendId: string;
    /* 推荐人名称 */
    recommendName: string;
    /* 备注信息 */
    remark: string;
    /* 签约开始时间 */
    appointmentStart: string;
    /* 签约结束 */
    appointmentEnd: string;
    /* 客户标签列表 */
    tagList: TagListDto[]
    /* 申请留言，添加客户处使用 */
    applyMessage?: string;
}

/**
 * 申请客户/添加客户
 * @param parameter
 */
export function applyMerchants(params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjoperation/merchantManage/applyMerchants",
        method: "post",
        data: {...params, ...assignParams()},
    });
}

/**
 * 客户设置/更新客户
 * @param parameter
 */
export function modifyMerchants(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjoperation/merchantManage/modifyMerchants",
        method: "post",
        data: parameter,
    });
}

export class CompanyAddDto {
    /* 公司名称 */
    companyName: string;
    /* 行业 */
    industryId: string;
    /* 行业 */
    industryName: string;
    /* 职务 */
    postInfo: string;
    /* 规模 */
    dimensionsId: string;
    /* 规模 */
    dimensionsName: string;
    /* 注册类型 */
    companyType: number;
    /* 手机号码 */
    registMobile: string;
    /* 独立编码 仅限中文和数字组成 */
    companyCode: string;
    /* 产业合作方邀请码 */
    versionCode:string
}

/**
 * 新增公司 / 代客注册
 * @param parameter
 */
export function addCompany(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjoperation/companyManage/addCompany",
        method: "post",
        data: parameter,
    });
}

/**
 * 员工列表
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function GetEmployeeList(params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<any>>({
        url: '/cykjusercenter/Departmentstaff/server/getEmployeeList',
        method: 'get',
        params: {...params, ...assignParams()}
    })
}

/**
 * 获取部门列表
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function GetOrganizationInfoAll(params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<any>>({
        url: '/cykjusercenter/DepartmentQuery/getOrganizationInfoAll',
        method: 'post',
        data: {...params, ...assignParams()}
    })
}

export class MerchantExInfoDto {
    /* 统一社会信用代码 */
    socialCreditCode?: string;
    /* 成立时间 */
    foundTime?: string;
    /* 省市区编号 */
    enterpriseAddressId?: string;
    /* 省市区全称 */
    addressFullName?: string;
    /* 企业地址详细地址 */
    enterpriseAddressDetail?: string;
    /* 所属行业 */
    industry?: string;
    /* 所属行业描述 */
    industryName?: string;
    /* 合作起始月份 */
    cooperateStart?: string;
    /* 企业近两年营业收入(万元) */
    lastTwoYearAmount?: string;
    /* 企业类型 */
    cusType?: string;
    /* 企业类型名称 */
    cusTypeName?: string;
    /* 企业电话 */
    enterprisePhone?: string;
    /* 上一年合作总额 */
    preYearTotalAmount?: string;
    /* 实控人姓名 */
    actualControllerName?: string;
    /* 实控人身份证号 */
    actualControllerId?: string;
    /* 实控人手机号码 */
    actualControllerMobile?: string;
}

/**
 * 获取客户扩展信息
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function getMerchantExInfo(params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<MerchantExInfoDto>>({
        url: '/cykjmerchantsborrower/MerchantsInfoExtendManagement/getMerchantExInfo',
        method: 'get',
        params: {...params, ...assignParams()},
    })
}

export class CompanyListOfQuotaDto extends CustomerListDto {
    /* 客户编号 */
    merchantId?: string;
    /* 客户名称 */
    merchantName?: string;
    /* 客户备注名 */
    merchantRemark?: string;
    /* 客户编码 */
    merchantCode?: string;
    /* 公司地址 */
    addressFullName?: string;
    /* 客户类别 */
    merchantTypeName?:string;
}

/**
 * 获取可选核心企业客户列表
 * @param parameter
 */
export function getCompanyListOfQuota(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<CompanyListOfQuotaDto>>>({
        url: "/cykjmerchantsborrower/companyOperations/getCompanyListOfQuota",
        method: "get",
        params: {...assignParams(), ...parameter},
        // headers: {
        //     [ContentType]: 'application/x-www-form-urlencoded',
        // },
        // transformRequest(params) {
        //     return Object.keys(params)
        //         .map((k) => `${k}=${encodeURIComponent(params[k])}`)
        //         .join("&");
        // }
    });
}

export class toQuotaResDto {
    /* 接收标识 */
    sendFlag?: string;
    /* 免登url */
    redirectUrl?: string;
    /* 产业通客户编号 */
    cytUserId?: string;
    /* 合作方企业编号 */
    companyId?: string;
    /* 客户编号 */
    merchantId?: string;
    /* 飞贷客户编号 */
    fdUserId?: string;
}

/**
 * 去出额
 * @param parameter
 */
export function jump2Quota(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<toQuotaResDto>>({
        url: "/cykjmerchantsborrower/companyOperations/jump2Quota",
        method: "post",
        data: {...assignParams(), ...parameter}
    });
}

/**
 * 去还款
 * @param parameter
 */
export function jump2Repayment(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<toQuotaResDto>>({
        url: "/cykjmerchantsborrower/companyOperations/jump2Repayment",
        method: "post",
        data: {...assignParams(), ...parameter}
    });
}

/**
 * 判断用户是否绑定手机号
 * @param parameter
 */
export function checkUserBindMobile(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjmerchantsborrower/companyOperations/checkUserBindMobile",
        method: "post",
        data: parameter
    });
}

/* 提交借款申请 */
export function submitLoanOrder(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<toQuotaResDto>>({
        url: "/cykjmerchantsborrower/companyOperations/submitLoanOrder",
        method: "post",
        data: parameter,
    });
}


/**
 * @description: 判断公司是否为核心企业
 * @param {Parameter} params
 * @return {*}
 */
export function checkIsCoreEnterprice (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjmerchantsborrower/companyConfigInformationManagement/checkIsCoreEnterprice',
    method: 'get',
    params: { ...params }
  })
}

/**
 * 获取转换后公司唯一编码
 * @param parameter
 */
export function getCompanyCode(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjoperation/companyQuery/getCompanyCode",
        method: "post",
        data: parameter,
        extraParams: {
            showLoading: false
        }
    });
}

/**
 * 获取是否显示产业合作
 * @param params
 */
 export function haveAuditPermission(params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
      url: "/cykjSystemAudit/TCP/haveAuditPermission",
      method: "get",
      params: { ...params }
  });
}
